import React, { useEffect, useState } from 'react';
import { Grid, styled, TextField, Paper, Button, Typography, Box } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PageHeader from '../../../components/PageHeader';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../../api';
import { PMTResponse, TrackingCardPMT } from '../../../schema/external';

const PMTDetail: React.FC = () => {
  const { id } = useParams();
  const [data, setData] = useState<TrackingCardPMT | null>(null);

  useEffect(() => {
    api.get<PMTResponse<TrackingCardPMT>>(`bypass/pmt/${id}`).then((res) => {
      const { data } = res;
      if (data.data) {
        setData(data.data);
      }
    });
  }, []);

  return (
    <RootContainer>
      <PageHeader text="อุปกรณ์ติดตามบุคคล" />

      <Button component={Link} to={`/tracking-card`} sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        หมายเลขอุปกรณ์ติดตาม
      </Button>

      <Paper>
        <Typography variant="h6" sx={{ px: 2, pt: 2, pb: 1 }}>
          {'อุปกรณ์ติดตามบุคคล'}
        </Typography>

        <Box sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="รหัสอุปกรณ์"
                variant="outlined"
                placeholder="รหัสอุปกรณ์"
                value={data?.dev_eui ? data.dev_eui : ''}
                autoComplete="off"
                disabled={!data?.dev_eui}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ชื่ออุปกรณ์"
                variant="outlined"
                placeholder="ชื่ออุปกรณ์"
                value={data?.dev_name ? data.dev_name : ''}
                autoComplete="off"
                disabled={!data?.dev_name}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="เลขรหัสบัตรผู้ใช้งาน"
                variant="outlined"
                placeholder="เลขรหัสบัตรผู้ใช้งาน"
                value={data?.occupied_id ? data.occupied_id : ''}
                autoComplete="off"
                disabled={!data?.occupied_id}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Battery level"
                variant="outlined"
                placeholder="Battery level"
                value={data?.battery_level ? data.battery_level : ''}
                autoComplete="off"
                disabled={!data?.battery_level}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="lat"
                variant="outlined"
                placeholder="lat"
                value={data?.lat ? data.lat : ''}
                autoComplete="off"
                disabled={!data?.lat}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="long"
                variant="outlined"
                placeholder="long"
                value={data?.long ? data.long : ''}
                autoComplete="off"
                disabled={!data?.long}
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </RootContainer>
  );
};

export default PMTDetail;

const RootContainer = styled('div')`
  padding: 24px;
`;
